const SensitivePropsDisallowed = ['destination','headers'];

export default SensitivePropsDisallowed;
